import { html } from "lit";
import { navigateToControlBox } from '../utils.js';

export default  (jid) => {
    return html`<converse-icon size="1em" class="fa fa-angle-right" color="rgb(255, 215, 0)" @click="${() => navigateToControlBox(jid)}"></converse-icon>`
}
